<template>
  <svg
    width="22px"
    height="22px"
    viewBox="0 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M 16.499 12.289 L 16.499 10.901 C 16.499 8.822 13.747 8.822 13.747 10.901 L 13.747 9.515 C 13.747 7.435 10.995 7.435 10.995 9.515 L 10.995 3.968 C 10.995 1.885 8.243 1.885 8.243 3.968 L 8.243 17.257 L 5.109 14.076 C 3.822 12.778 1.886 14.74 3.174 16.038 L 8.681 21.591 C 8.941 21.851 9.305 22 9.659 22 L 17.915 22 C 18.674 22 19.25 21.371 19.25 20.604 L 19.25 12.289 C 19.25 10.21 16.499 10.21 16.499 12.289"
      fill="#000"
    ></path>
    <path
      d="M 6.434 6.132 C 6.793 5.994 6.965 5.58 6.812 5.224 C 6.665 4.889 6.588 4.523 6.588 4.154 C 6.588 3.079 7.243 2.049 8.34 1.6 C 8.692 1.457 9.071 1.382 9.451 1.383 C 10.218 1.376 10.957 1.679 11.5 2.22 C 12.014 2.733 12.319 3.429 12.319 4.152 C 12.319 4.506 12.246 4.868 12.089 5.224 C 11.936 5.58 12.11 5.994 12.469 6.133 C 12.835 6.28 13.254 6.118 13.408 5.766 C 13.641 5.236 13.75 4.688 13.75 4.152 C 13.75 3.053 13.294 2.021 12.528 1.259 C 11.713 0.447 10.604 -0.008 9.451 0 C 8.878 -0.001 8.311 0.111 7.78 0.327 C 6.138 1.001 5.157 2.541 5.157 4.154 C 5.157 4.695 5.267 5.242 5.495 5.766 C 5.649 6.118 6.07 6.28 6.434 6.132"
      fill="#FFC900"
    ></path>
  </svg>
</template>
